import * as React from "react"

import env from "../../../../../env"

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    attributes: Record<string, string>
    label: string
    prependApplicationPath?: boolean
}

export const Link = ({
    attributes,
    href,
    label,
    prependApplicationPath = true,
    ...attrs
}: Props): JSX.Element => {
    const finalHref = prependApplicationPath
        ? `${env.applicationPath}/${href}`
        : href

    return (
        <a href={finalHref} {...attrs} {...attributes}>
            {label}
        </a>
    )
}

export default Link
